<h1 mat-dialog-title class="p-2 text-center">Nouvelle mesure </h1>
<div class="p-3">
    <div class="col">

        <div class="row">
            <mat-form-field class="col">
                <mat-label>Profondeur (m)</mat-label>
                <input matInput placeholder="Profondeur (m)" type="number" [(ngModel)]="NewPrelevement.Profondeur" [formControl]="ValidProfMax">
                <mat-error *ngIf="ValidProfMax.hasError('max')">
                    Max {{PMAX}}m
                </mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col">
                <mat-label>Matériel</mat-label>
                <mat-select placeholder="Matériel" [(ngModel)]="NewPrelevement.Materiel" required>
                    <mat-option *ngFor="let o of MaterielPonctuelList; let i = index" [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="row" *ngIf="NewPrelevement.Materiel !== EMaterielEauPonctuel.Manuel">
            <mat-form-field class="col">
                <mat-label>Référence Matériel</mat-label>
                <input matInput placeholder="Référence Matériel"  [(ngModel)]="NewPrelevement.ReferenceMateriel">
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col">
                <mat-label>Température Glacière</mat-label>
                <input matInput placeholder="Température Glacière" type="number" [(ngModel)]="NewPrelevement.TemperatureGlaciere">
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col">
                <mat-label>Nb Flacon</mat-label>
                <input matInput placeholder="Nb Flacon" type="number" [(ngModel)]="NewPrelevement.NbFlacon">
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col">
                <mat-label>Remarques, écart</mat-label>
                <input matInput placeholder="Remarques, écart"  [(ngModel)]="NewPrelevement.Comment">
            </mat-form-field>
        </div>
        <div class="row">
            <button class="col mx-3 my-2" appPreventDoubleClick [throttleTime]="200" mat-raised-button color="accent" (throttledClick)="onCancel()">
                Annuler<mat-icon>undo</mat-icon>
            </button>
        </div>
        <div class="row">
            <button class="col mx-3 my-2" appPreventDoubleClick [throttleTime]="200" mat-raised-button color="primary" (throttledClick)="onConfirm()" [disabled]="!CanAddNewMeasure()">
                Enregistrer<mat-icon>save</mat-icon>
            </button>
        </div>
    </div>
</div>